import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { batch, useDispatch } from 'react-redux';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { goToFastSignUp } from 'components/Questionnaire/actions';
import CONSTANTS from 'components/Authentication/constants';
import { useTranslation } from 'utils/modifiedTranslation';

const useStyles = makeStyles(() => ({
  savedButtonAnimation: {
    animation: '$fadeIn 1s ease-in, $shake 2s ease-in 0.5s 5 ',
  },
  fadeInAnimation: {
    animation: '$fadeIn 1s ease-in',
  },
  savedButton: {
    minHeight: 40,
    minWidth: 80,
    padding: '9px 20px',
    border: 'none',
    borderRadius: '20px',
    background: '#F2F2F7',
    fontSize: 16,
    color: 'rgba(33, 51, 50, 1)',
    cursor: 'pointer',
    transition: 'all 0.5s ease',
    '&:hover': {
      color: 'rgba(33, 51, 50, 0.7)',
      '& svg': {
        opacity: 0.7,
      },
    },
  },
  savedButtonContentWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  optionCheckBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    height: 16,
    width: 16,
    marginRight: 9,
  },

  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '40%': {
      opacity: 0.5,
    },
    '80%': {
      opacity: 1,
    },
    '100%': {
      opacity: 1,
    },
  },
}));

export const SaveProfileButton = ({ isLoggedUser }) => {
  const { t } = useTranslation();
  const fragmentRef = useRef();
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClick = () => {
    if (!isLoggedUser) {
      batch(() => {
        dispatch({ type: CONSTANTS.SET_PROFILE_ID, payload: null });
        dispatch({ type: CONSTANTS.SET_PATIENT_ID, payload: null });
        dispatch(goToFastSignUp());
      });
    } else if (fragmentRef.current) {
      fragmentRef.current.classList.remove(classes.fadeInAnimation);
      setTimeout(() => {
        fragmentRef.current.classList.add(classes.fadeInAnimation);
      }, 0);
    }
  };

  return (
    <button
      className={cx(classes.savedButton, isLoggedUser ? classes.fadeInAnimation : classes.savedButtonAnimation)}
      type="button"
      onClick={handleClick}
    >
      <div className={classes.savedButtonContentWrapper} ref={fragmentRef}>
        {isLoggedUser && (
          <div className={classes.optionCheckBox}>
            <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.95054 5.42344L1 6.65768C1.59591 7.20915 8.29039 13.4037 8.65666 13.7451L9.6508 12.7705L20.4527 2.16713L19.4266 1L8.52876 9.68931L1.95054 5.42344Z" fill="#F4D06F" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

          </div>
        )}
        {isLoggedUser ? t('navbar.save_profile.saved') : t('navbar.save_profile.save')}
      </div>
    </button>
  );
};

SaveProfileButton.propTypes = {
  isLoggedUser: PropTypes.bool,
};
